import { FC, useEffect, useState } from 'react';
import { Table, Flex } from 'antd';
import styles from './index.module.scss';
import { IDataItem, IProps } from './type';
import ModalDialog from '../../ModalDialog';
import { transformToData } from './helpers';
import columns from './columns';
import SDropdown from '../../FormElements/SDropdown';
import SLabelTitle from '../../FormElements/SLabelTitle';
import { useAppSelector } from '../../../store';

const SummarySheetModal: FC<IProps> = (props) => {
  const [data, setData] = useState<IDataItem[]>([]);

  const { organization } = useAppSelector(
    (state) => state.userReducer.userInfo,
  );

  useEffect(() => {
    if (organization !== 1 && props.open) {
      props.handleChangeSummaryTable(organization.toString());
    }
  }, [organization, props.open]);

  useEffect(() => {
    if (props.summaryTable.length) {
      const data = transformToData(props.summaryTable, props.statusChoices);
      setData(data);
    } else {
      setData([]);
    }
  }, [props.summaryTable, props.statusChoices]);

  return (
    <ModalDialog
      title={props.title}
      subTitle={props.subTitle}
      open={props.open}
      isButtonsDisplayed={false}
      handleOk={props.handleSubmit}
      handleCancel={props.handleCancel}
    >
      <Flex vertical gap={20}>
        <Flex vertical gap={2}>
          <SLabelTitle>Şirket Bilgileri</SLabelTitle>
          <SDropdown
            className={styles.input}
            placeholder="Şirket Seçiniz"
            value={
              organization !== 1
                ? props.organizations.find((item) => item.id === organization)
                    ?.name
                : undefined
            }
            disabled={organization !== 1}
            options={props.organizations.map((item) => ({
              value: item.id,
              label: item.name,
            }))}
            onChange={props.handleChangeSummaryTable}
          />
        </Flex>
        <Table
          dataSource={data}
          columns={columns}
          pagination={false}
          className={styles.table}
        />
      </Flex>
      <Flex vertical gap={10} className={styles.noteContainer}>
        <div className={styles.note}>
          * Dosya takiplerinde hasar tarihi değil, ihbar tarihi baz
          alınmaktadır.
        </div>
        <div className={styles.note}>
          ** Yurtiçi hasarlarında tek bir hasara bağlı demirbaş, emtia, ecs
          hasarları için ayrı ayrı dosya açtırılmaktadır. Aynı hasara bağlı
          farklı hasar dosyaları tek bir hasar dosyası olarak baz alınmaktadır.
        </div>
      </Flex>
    </ModalDialog>
  );
};

export default SummarySheetModal;
